"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOffersType = void 0;
exports.OffersTabs = OffersTabs;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const getOfferPromotionStatus_1 = require("@src/helpers/getOfferPromotionStatus");
const dayjs_1 = __importDefault(require("dayjs"));
const OffersTable_1 = require("./OffersTable");
var EOffersTabKey;
(function (EOffersTabKey) {
    EOffersTabKey["MY_ACTIVE_OFFERS"] = "MY_ACTIVE_OFFERS";
    EOffersTabKey["MY_DRAFT_OFFERS"] = "MY_DRAFT_OFFERS";
    EOffersTabKey["MY_INACTIVE_OFFERS"] = "MY_INACTIVE_OFFERS";
})(EOffersTabKey || (EOffersTabKey = {}));
var EOffersType;
(function (EOffersType) {
    EOffersType["active"] = "active";
    EOffersType["notActive"] = "notActive";
    EOffersType["drafts"] = "drafts";
})(EOffersType || (exports.EOffersType = EOffersType = {}));
function transformOffers(offers) {
    return offers.map(offer => {
        var _a, _b;
        return ({
            id: offer.id,
            title: offer.title,
            viewsCount: offer.viewsCount,
            applicationCount: offer.offer_applications.length,
            deadline: offer.deadline,
            isPromoted: (0, getOfferPromotionStatus_1.getOfferPromotionActiveStatus)(offer.companyPaymentOfferPromotions, offer.id),
            promotedUntil: (_b = (_a = offer.companyPaymentOfferPromotions) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
                if ((0, dayjs_1.default)(a.endDate).isBefore((0, dayjs_1.default)(b.endDate))) {
                    return 1;
                }
                if ((0, dayjs_1.default)(a.endDate).isAfter((0, dayjs_1.default)(b.endDate))) {
                    return -1;
                }
                return 0;
            })[0]) === null || _b === void 0 ? void 0 : _b.endDate,
            createdAt: offer.createdAt,
        });
    });
}
function OffersTabs({ openArchiveModal }) {
    const intl = (0, react_intl_1.useIntl)();
    const { myOffers } = (0, admin_context_1.useAdminContextValue)();
    const myActiveOffers = transformOffers(myOffers.active);
    const myNotActiveOffers = transformOffers(myOffers.notActive);
    const myDraftOffers = transformOffers(myOffers.drafts);
    return ((0, jsx_runtime_1.jsxs)(elements_1.Tabs.Container, { children: [(0, jsx_runtime_1.jsx)(elements_1.Tabs.TabPane, { tab: intl.formatMessage({
                    id: 'admin.offers.active',
                }), children: (0, jsx_runtime_1.jsx)(OffersTable_1.OffersTable, { offers: myActiveOffers, openArchiveModal: openArchiveModal, type: EOffersType.active }) }, EOffersTabKey.MY_ACTIVE_OFFERS), myDraftOffers.length > 0 && ((0, jsx_runtime_1.jsx)(elements_1.Tabs.TabPane, { tab: (0, jsx_runtime_1.jsx)("span", { className: "p-r-l", children: (0, jsx_runtime_1.jsx)(elements_1.Badge, { count: myDraftOffers.length, offset: [16, 8], children: intl.formatMessage({
                            id: 'admin.offers.drafts',
                        }) }) }), children: (0, jsx_runtime_1.jsx)(OffersTable_1.OffersTable, { offers: myDraftOffers, type: EOffersType.drafts }) }, EOffersTabKey.MY_DRAFT_OFFERS)), myNotActiveOffers.length > 0 && ((0, jsx_runtime_1.jsx)(elements_1.Tabs.TabPane, { tab: intl.formatMessage({
                    id: 'admin.offers.archived',
                }), children: (0, jsx_runtime_1.jsx)(OffersTable_1.OffersTable, { offers: myNotActiveOffers, type: EOffersType.notActive }) }, EOffersTabKey.MY_INACTIVE_OFFERS))] }));
}
